import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, className = "", delay = 0, as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={fadeUp}
      custom={delay}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
    >
      {children}
    </MotionTag>
  );
};

// Kinetic line-by-line masked reveal for hero headlines
export const KineticHeadline = ({ lines = [], className = "", testId }) => {
  return (
    <h1 className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              ease: [0.22, 1, 0.36, 1],
              delay: 0.15 + i * 0.13,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
};
